import React from 'react'
import { Typography, TypographyLongForm, MediaImageStandard } from 'components/Contentful'
import { Box } from '@achieve/ascend'
import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import styles from './StoryBlocksAuthor.module.scss'
import SlideOnVisible from 'components/SlideOnVisible'
import {
  SLIDE_ON_VISIBLE_DURATION_DEFAULT,
  SLIDE_ON_VISIBLE_EASING_DEFAULT,
  SLIDE_ON_VISIBLE_TIMEOUT_DEFAULT,
} from 'constants/animation'
import classNames from 'classnames'

const StoryBlocksAuthor = ({ content }) => {
  const { StoryBlocksAuthorGrid } = useMemoizedContentGetter(content, ['StoryBlocksAuthorGrid'])

  return (
    <Section
      contain={false}
      className={styles['story-blocks-container']}
      data-testid="StoryBlocksAuthor_section"
    >
      <Box className={styles['story-blocks-grid']}>
        {StoryBlocksAuthorGrid &&
          StoryBlocksAuthorGrid?.gridItemsCollection?.items?.map((card, index) => {
            return (
              <Box
                key={index}
                className={styles['story-blocks-item']}
                data-align-left={!(index % 2 == 0)}
              >
                <Box className={styles['story-blocks-item-img']}>
                  <SlideOnVisible
                    duration={SLIDE_ON_VISIBLE_DURATION_DEFAULT}
                    timeout={SLIDE_ON_VISIBLE_TIMEOUT_DEFAULT}
                    easing={SLIDE_ON_VISIBLE_EASING_DEFAULT}
                  >
                    <div className={styles['block-img']}>
                      <div className="block lg:hidden">
                        <MediaImageStandard
                          content={card?.image}
                          alt={card?.altText}
                          layout="fixed"
                          objectFit="cover"
                          width={340}
                          height={360}
                        />
                      </div>
                      <div className="hidden lg:block">
                        <MediaImageStandard
                          content={card?.image}
                          alt={card?.altText}
                          layout="fill"
                          objectFit="cover"
                          objectPosition="center top"
                        />
                      </div>
                    </div>
                  </SlideOnVisible>
                </Box>
                <Box
                  className={styles['story-blocks-item-content']}
                  data-testid="story-blocks-item-content"
                >
                  <SlideOnVisible
                    duration={1150}
                    timeout={SLIDE_ON_VISIBLE_TIMEOUT_DEFAULT}
                    easing={SLIDE_ON_VISIBLE_DURATION_DEFAULT}
                  >
                    <div>
                      <Typography
                        content={card?.author}
                        variant="bodySm"
                        fontWeight="bold"
                        className={styles['story-blocks-item-author']}
                        data-testid="story-blocks-item-author-name"
                      />
                      <Typography
                        content={card?.title}
                        className={classNames(
                          styles['story-blocks-item-title'],
                          'displayMd lg:displayLg !font-bold'
                        )}
                        fontWeight="bold"
                        data-testid="story-blocks-item-title"
                      />
                      {card?.text?.json?.content?.map((text, cardIndex) => {
                        return (
                          <TypographyLongForm
                            key={cardIndex}
                            content={text}
                            className={cardIndex === 0 ? 'bodySm lg:bodyLg' : 'bodySm'}
                            fontWeight="regular"
                          />
                        )
                      })}
                    </div>
                  </SlideOnVisible>
                </Box>
              </Box>
            )
          })}
      </Box>
    </Section>
  )
}
export { StoryBlocksAuthor }
export default StoryBlocksAuthor
